import { Injectable } from '@angular/core';
import { DynamicOrchestrator, OrchestratorComponents } from '@games/shared/orchestrator';

@Injectable()
export class BlindReadingOrchestrator extends DynamicOrchestrator {
  preForm = () => {
    return {
      padding: {
        for: 'outerBox',
        width: 12,
        height: 20,
        gaps: 0.5,
      },
    };
  };

  providePlay() {
    this.form({});
  }
}
